// Sticky Navbar
require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');
var div_top = $('.menu_items_bottom').offset().top;
var sidebar_top = 0;
var sidebar_left = 0

if ($('.products.by-family').length) {
    $('.products-tabs').removeClass('products-green-active products-by-app-active').addClass('products-by-family-active')
}
if ($('.products.products-by-app-active').length) {
    $('.products-tabs').removeClass('products-green-active products-by-family-active').addClass('products-by-app-active')
}
if ($('.products.green').length) {
    $('.products-tabs').removeClass('products-by-family-active products-by-app-active').addClass('products-green-active')
}



function initsidebarpos() {




    if ($('.sidebar-content').length > 0) {
        $('.sidebarCollapse').on('click', function() {
            $('.sidebar-content').toggleClass('active');
            $('.sidebar-content #sidebar, .sidebar-content #content').toggleClass('active');
            $('.sidebar-content .collapse.in').toggleClass('in');
            $('.sidebar-content a[aria-expanded=true]').attr('aria-expanded', 'false');
        });

        sidebar_top = $('.sidebar-content #content').offset().top;
        sidebar_left = (($(window).outerWidth() - ($('.sidebar-content').parent().outerWidth())) / 2) + 7


    }


}
$('.nav-tabs a').on('shown.bs.tab', function(event) {
    sidebar_top = 0;
    sidebar_left = 0;
    $('.sidebar-content #sidebar').css({
        position: 'absolute',
        left: '0px',
        top: '0px',

    });
    console.log('do ittt')
    initsidebarpos()

});




window.addEventListener("load", function() {
    fixedNavMobile();
    initcertificates();
    initmasonary();
    animatestrip();
    initsidebarpos();
    initfunctions();
    $('.preloaderWrapper').fadeOut(1100);

}, false);

function animatestrip() {
    if ($('.products.by-app .products-cat').length) {


        $('.products.by-app .products-cat').each(function(index, value) {


            $(this).find('.colored-strip').css({
                    'height': $(this).find('.name').outerHeight(),
                    'top': $(this).find('.des').position().top,

                }).data('origHeight', $(this).find('.name ').outerHeight())
                .data('origtop', $(this).find('.des').position().top);
        });



        $(".products.by-app .products-cat").mouseenter(function() {
            var self = $(this);
            self.find(".colored-strip").css({
                "height": "100%",
                'top': 0,
            });
        }).mouseleave(function() {
            var self = $(this);
            var striped_span = self.find('.colored-strip')
                //

            //
            setTimeout(function() {

                striped_span.css({
                    'height': striped_span.data('origHeight'),
                    'top': striped_span.data('origtop')


                })
            }, 0);
        });
    }
}

function initmasonary() {
    if ($('.grid .grid-item')) {
        if ($('.cats.cats-by-app').length) {
            $('.grid-item').eq(6).removeClass('col-md-3').addClass(' col-md-6')
            $('.grid-item').eq(9).removeClass('col-md-3').addClass(' col-md-6')
                // $('.grid-item').eq(11).removeClass('col-md-3').addClass(' col-md-9')

        }
        if ($('.cats.cats-by-family').length && !$('.cats.cats-by-family').hasClass('p-home-page')) {
            $('.grid-item').eq(1).addClass('full-height')
            $('.grid-item').eq(3).addClass('full-height')

        }
        const Masonry = require('masonry-layout')
        var grid = document.querySelector('.grid')
        var msnry = new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
        });

    }


    animatestrip();




}

function initcertificates() {
    const slick = require('slick-carousel');


    if ($('.slick-certificates')) {
        $('.slick-certificates').slick({
            dots: true,
            infinite: false,
            arrows: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }

            ]
        });
    }
}

window.onresize = function(event) {
    setTimeout(function() {
        initfunctions();
        animatestrip();
        fixedNavMobile();
    }, 250);

};

function initfunctions() {
    var hoveredItems = document.querySelectorAll('.products.by-family .grid-item'),
        len = hoveredItems.length;
    if (len > 0) {
        for (var i = 0; i < len; i++) {


            $(hoveredItems[i]).mouseover(function() {
                $(this).find('.cat').addClass('hovered').focus();
            }).mouseout(function() {
                $(this).find('.cat').removeClass('hovered');

            })
        }
    }




    animatedHover('menu_items_bottom .navbar-nav', 'nav-item')
        // animatedHover('page-banner .nav-tabs', 'nav-link')
    initsidebarpos()
    scrollbar();

}



if ($("a.scrollLink").length) {

    $("a.scrollLink").click(function(event) {

        $('.sidebar-content').removeClass('active');
        $('.sidebar-content #sidebar, .sidebar-content #content').removeClass('active');
        $('.sidebar-content .collapse.in').removeClass('in');


        event.preventDefault();
        $(this).addClass('active').siblings().removeClass('active')
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 50
        }, 500);
    });

}

function scrollbar() {
    // let $ = require('jquery');

    $(".scroll-bar").mCustomScrollbar();
}

function getpage(page, img, product_search) {

    console.log(page, img)
    if (($('.page-banner  .products-search').length > 0)) {
        $('.page-banner  .products-search').load(product_search);

    }
    $('.page-container#Content').load(page);
    $('.page-banner .img-bnner').load(img);
    initsidebarpos()

    setTimeout(function() {
        initcertificates();
        initmasonary();
        scrollbar();

        window.initValidation();
        // window.initMap();


    }, 200);
    // }
}


initfunctions();

function animatedHover(containerSelector, itemSelector) {

    if ((($('.' + containerSelector).length) && $('.' + itemSelector).length) && ($('.' + containerSelector).find('.' + itemSelector + '.active').length)) {
        var leftPos, newWidth, $magicLine;
        if (!$('.' + containerSelector).find('.magic-line').length) {
            $('.' + containerSelector).append("<span class='magic-line'></span>");

        }
        $magicLine = $('.' + containerSelector).find('.magic-line');
        $magicLine.width($('.' + containerSelector).find('.' + itemSelector + '.active').innerWidth())
            .css('left', $('.' + containerSelector).find('.' + itemSelector + '.active').position().left)
            .data('origLeft', $('.' + containerSelector).find('.' + itemSelector + '.active').position().left)
            .data('origWidth', $('.' + containerSelector).find('.' + itemSelector + '.active').innerWidth());

        // $('.' + containerSelector).find('.' + itemSelector).click(function() {


        //     if ($(this).attr("data-href")) {
        //         var $thisElement = $(this);
        //         getpage($thisElement.attr("data-href") + ' #Content > *', $thisElement.attr("data-href") + ' .page-banner .img-bnner img', $thisElement.attr("data-href") + ' .page-banner .products-search > *');
        //         $thisElement.addClass('active').siblings().removeClass('active');
        //         window.history.pushState("", "", $thisElement.attr("data-href"));

        //     }

        //     if ($(this).attr("data-gtag")) {
        //         console.log($(this).attr("data-gtag"))
        //         gtag('event', $(this).attr("data-gtag"))


        //     }
        //     $('.products-tabs').removeClass('products-by-app-active  products-green-active products-by-family-active')
        //     if ($(this).hasClass("by-app")) {
        //         $('.products-tabs').addClass('products-by-app-active')
        //     } else if ($(this).hasClass("green-product")) {
        //         $('.products-tabs').addClass('products-green-active')
        //     } else {
        //         $('.products-tabs').addClass('products-by-family-active')

        //     }


        //     $magicLine.css({
        //         "left": $thisElement.position().left,
        //         "width": $thisElement.innerWidth()
        //     });
        //     $magicLine
        //         .data('origLeft', $thisElement.position().left)
        //         .data('origWidth', $thisElement.innerWidth());
        //     return false;
        // });

        /*Magicline hover animation*/
        $('.' + containerSelector).find('.' + itemSelector).hover(function() {
            var $thisElementBar = $(this);
            // alert($thisElementBar);
            leftPos = $thisElementBar.position().left;
            newWidth = $thisElementBar.innerWidth();


            if (!$('.' + containerSelector).hasClass('not-animated-hovered')) {
                console.log('hover')
                $magicLine.css({
                    "left": leftPos,
                    "width": newWidth
                });

            }
            // }
        }, function() {
            console.log('out')
            $magicLine.css({
                "left": $magicLine.data('origLeft'),
                "width": $magicLine.data('origWidth')
            });
        });
    }
    if ($('.products-tabs .product-tab.active').length) {
        var selected = $($('.products-tabs .product-tab.active'));
        if (selected.hasClass("by-app")) {
            $('.products-tabs').addClass('products-by-app-active')
        } else if (selected.hasClass("green-product")) {
            $('.products-tabs').addClass('products-green-active')
        } else {
            $('.products-tabs').addClass('products-by-family-active')

        }
    }
}



console.log('sidebar_top:', sidebar_top);
$(window).scroll(function() {
    var window_top = $(window).scrollTop();
    if (window_top > div_top) {
        $('.menu_items_bottom').removeClass('position-relative').addClass('sticky-navbar');
        $('.cd-auto-hide-header').next().css({
            "marginTop": $('.menu_items_bottom').innerHeight()
        });
    } else {
        $('.menu_items_bottom').addClass('position-relative').removeClass('sticky-navbar');
        $('.cd-auto-hide-header').next().css({
            "marginTop": "0px"
        });
    }

    if (($('.sidebar-content').length > 0) && ($(window).width() >= 992)) {

        sidebar_left = (($(window).outerWidth() - ($('.sidebar-content').parent().outerWidth())) / 2) + 7;
        sidebar_top = $('.sidebar-content #content').offset().top;

        if (window_top > sidebar_top - 70) {
            $('.sidebar-content #sidebar').css({
                position: 'fixed',
                top: '70px',
                left: sidebar_left
            });



        } else {
            $('.sidebar-content #sidebar').css({
                position: 'absolute',
                left: '0px',
                top: '0px',




            });

        }
    }
});

// Active label
$("form :input,form textarea").focus(function() {
    $("label[for='" + this.id + "']").addClass("labelfocus");
}).blur(function() {
    $("label").removeClass("labelfocus");
});

// fixed Icons Top
if ($('.fixed-icons-top').length) {
    $('.fixed-icons-top').css({
        'top': $('.cd-auto-hide-header').innerHeight() + 10
    });
}

// $('.nav-products .nav-link').click(function() {
//     setTimeout(function() {
//          animatestrip();
//     }, 350);
// });

// info Hub
$("body").delegate(".show-video", "click", function() {

    let videosrc = $(this).attr('videosrc');
    $('.sec-info-hub-videos').find('.embed-responsive-item').attr('src', videosrc);
    $(this).addClass('active').siblings().removeClass('active');
});

// Go To Section id


var section_id = window.location.hash;
if (section_id.length && $(section_id).length) {
    $('html, body').animate({
        scrollTop: 0
    }, 0);
    setTimeout(function() {
        $('html, body').animate({
            scrollTop: $(section_id).offset().top
        }, 2000);
    }, 1000)

}


function fixedNavMobile() {
    if ($(window).width() <= 992) {
        $('body').css('paddingTop', $('.menu_items_top').innerHeight());
    } else {
        $('body').css('paddingTop', '0px');

    }
}

// Scroll To Section
$('.nav-products .nav-link').click(function() {
    $('html, body').animate({
        scrollTop: $('#' + $(this).data('scroll')).offset().top - $('.cd-auto-hide-header').innerHeight()
    }, 500);

});

// Custom File
$('input[type="file"]').change(function(e) {
    var fileName = e.target.files[0].name;
    // $('.custom-file-label').html(fileName);
    $('.custom-file-label').attr('data-browse', fileName);
});


// $(window).on('load', function() {
//     // alert("Window Loaded");
//     initfunctions();
// });


// test
$('.distributorModal').on('hidden.bs.modal', function(e) {
    $(this).find('.modal-body').empty();
})


$(".fixed-icons-top .container-icon.search .form-control").focusin(function() {
    $(this).parents('.container-icon').addClass('active')
});

$(".fixed-icons-top .container-icon.search .form-control").focusout(function() {
    $(this).parents('.container-icon').removeClass('active')
});


// $(window).scroll(function() {

//     console.log('page-container' + $('.page-container').offset().top);
//     console.log('ScrollTop ' + $(window).scrollTop());
//     // if ($(window).scrollTop() + $(window).height() == $(document).height()) {
//     //     alert("bottom!");
//     // } else {
//     //     // alert("Done!");


//     // }


// });

$(window).scroll(function() {
    if ($(window).scrollTop() + $(window).height() > $('.footer').offset().top + 65) {
        // console.log("footer visible");
        $('.sidebar-content #sidebar .items-cats').addClass('scroll')
        $('.sidebar-content #sidebar').addClass('active-scroll')

    } else {
        // console.log("footer invisible");
        $('.sidebar-content #sidebar .items-cats').removeClass('scroll')
        $('.sidebar-content #sidebar').removeClass('active-scroll')
    }
});

$('.nav-products .nav-link').click(function() {
    setTimeout(function() {
        animatestrip();
    }, 350);
});